import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const AssignmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 16px;
  gap: 12px;
`;

export const AssignmentRowWrapper = styled.div<{
  $isDisabled?: boolean;
  $justifyContent?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ $justifyContent }) =>
    $justifyContent || 'space-between'};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
  height: 24px;
`;

export const AssignmentLabel = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  width: 80px;
  flex: 0 0 auto;
  color: ${theme.colors.secondary900};
  font-size: 12px;
  font-weight: 400;
`;
